export const defaultSEO = {
  title: "Pozivnica.hr - Digitalne pozivnice za vaše posebne trenutke",
  description:
    "Digitalne pozivnice - od uzbuđenja vjenčanja do radosti rođendana! Kreirajte jedinstvene online pozivnice za vjenčanja, rođendane i posebne prigode.",
  openGraph: {
    type: "website",
    locale: "hr_HR",
    url: "https://pozivnica.hr/",
    siteName: "Pozivnica.hr",
    images: [
      {
        url: "https://pozivnica.hr/cdn-cgi/image/width=1200,quality=80,format=auto/https://bucket.pozivnica.hr/ui-bucket/pozivnica.png",
        width: 1200,
        height: 1200,
        alt: "Pozivnica.hr Preview",
      },
    ],
  },
  twitter: {
    handle: "@pozivnica_hr",
    site: "@pozivnica_hr",
    cardType: "summary_large_image",
  },
};

export const pageSEO = {
  home: {
    title: "Pozivnica.hr - Kreirajte digitalne pozivnice",
    description:
      "Izradite jedinstvene digitalne pozivnice za vaša vjenčanja, rođendane i posebne prigode. Jednostavno i kreativno rješenje za vaše pozivnice.",
  },
  auth: {
    title: "Prijava - Pozivnica.hr",
    description:
      "Prijavite se na svoj Pozivnica.hr račun i započnite kreirati svoje digitalne pozivnice.",
  },
  dashboard: {
    title: "Moje Pozivnice - Pozivnica.hr",
    description:
      "Upravljajte svojim digitalnim pozivnicama i pratite odgovore uzvanika.",
  },
  create: {
    title: "Nova Pozivnica - Pozivnica.hr",
    description: "Kreirajte novu digitalnu pozivnicu za vaš poseban događaj.",
  },
};
